/**
 * This is a (working) set of keys that may appear in objects that are passed to that
 * logger that MUST not be transmitted externally to log aggregation partners or any storage service.
 *
 * THESE MUST BE LOWER CASE!!! They will not be .toLower()'ed Later!
 *
 */
export const SECURE_KEY_LIST = [
    'email',
    'secret',
    'token',
    'password',
    'pwd',
    'pass',
    'p',
    'cert',
    'certificate',
    'cred',
    'credential',
    'database',
    'database_url',
    'db',
    'db_url',
    'x-session-token',
    'oldemail',
    'newemail',
    'old_email',
    'new_email',
    'iin',
    'db_email',
] as const;

export type SECURE_KEY = (typeof SECURE_KEY_LIST)[number];

export const SECURE_KEY_MAP = SECURE_KEY_LIST.reduce((map, k) => {
    map[k] = true;
    return map;
}, {} as Record<SECURE_KEY, true>);
